module.exports = __webpack_public_path__ + "img/zj_station_icon.ca1fc1b4.png";